import { ErrorType } from 'interfaces/error';

export function errorMessage(err: keyof typeof ErrorType): string {
  const errorsTypes = ErrorType[err];
  return !!errorsTypes ? errorsTypes : 'Algo deu errado...';
}
